export const EmptyGuid = '00000000-0000-0000-0000-000000000000';

export const states: string[] = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

interface employmentType {
  name: string;
  value: string;
}

interface payType {
  name: string;
  value: string;
}

export const employmentTypes: employmentType[] = [
  { name: 'Full Time', value: 'full time' },
  { name: 'Part Time', value: 'part time' },
  { name: 'Temporary', value: 'temporary' },
  { name: 'Seasonal', value: 'seasonal' },
  { name: 'Internship', value: 'internship' },
];

export const payTypes: payType[] = [
  { name: 'Hourly', value: 'hourly' },
  { name: 'Salary', value: 'salary' },
  //{ name: 'Commission', value: 'commission' },
];

export const pricingTypes: payType[] = [
  { name: 'Per Student', value: 'per student' },
  { name: 'Per Unit', value: 'per unit' },
];

export const housingTypes = ['house', 'apartment'];

export const paymentTypes = ['monthly', 'for sale'];

export const DealTypes = {
  Deal: 'Deal',
  Housing: 'Housing',
  Job: 'JobOpportunity'
}

export const StatusValues = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  All: 'ALL'
}